import React from 'react'

const React_Coding_Practice_14 = () => {
  return (
    <div>
      <h1>Coding Pratice 14</h1>
    </div>
  )
}

export default React_Coding_Practice_14
